// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateStatusChangeModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_PRODUCTS_BY_CUSTOMER_STATUS_CHANGE_MODAL_VISIBILITY
        });

    };

export const updateProduct = product =>

    dispatch => {

        dispatch({
            product,
            type: actions.UPDATE_PRODUCTS_BY_CUSTOMER_PRODUCT
        });

        updateStatusChangeModalVisibility(true)(dispatch);

    };

export const resetProduct = () => ({
    type: actions.RESET_PRODUCTS_BY_CUSTOMER_PRODUCT
});



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/status-change-modal.js